import { get } from './P3Api';

async function getCoolersByVendor(vendorCode) {
  const items = [];
  let page = 0
  let response = await get(`vendors/${vendorCode}/coolers?page=${page}`);
  do {
    page++;
    items.push(...response);
    response = await get(`vendors/${vendorCode}/coolers?page=${page}`)
      .catch(error => {
        console.log(error.response);
    });
  } while (response);

  return items;
}

export { getCoolersByVendor};